namespace Portico.Models.Setup {

	export interface ISetup {
		// portal and setup data
		dataTables: DataTable[];
		dataTypes: DataType[];
		demo: Demo;
		demos: Portal[];
		portal: Portal;
		templates: DataGroup[];
	}

	export class Setup implements ISetup {
		// portal and setup data
		dataTables: DataTable[];
		dataTypes: DataType[];
		demo: Demo;
		demos: Portal[];
		portal: Portal;
		templates: DataGroup[];

		constructor(obj?: ISetup) {
			this.dataTables = [];
			this.dataTypes = [];
			this.demo = null;
			this.demos = [];
			this.portal = null;
			this.templates = [];

            if (obj) {
				if (obj.dataTables) {
					obj.dataTables.forEach((dataTable) => {
						this.dataTables.push(new DataTable(dataTable));
					});
				}

				if (obj.dataTypes) {
					obj.dataTypes.forEach((dataType) => {
						this.dataTypes.push(new DataType(dataType));
					});
				}

				if (obj.demo) {
					this.demo = new Demo(obj.demo);
				}

				if (obj.demos) {
					obj.demos.forEach((portal) => {
						this.demos.push(new Portal(portal));
					});
				}

				if (obj.portal) {
					this.portal = new Portal(obj.portal);
				}

				if (obj.templates) {
					obj.templates.forEach((dataGroup) => {
						this.templates.push(new DataGroup(dataGroup));
					});
				}
            }
        }
    }
}
